import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ShapeAnimation from '../../ShapeAnimation';
const settings = {
    arrows: false,
    nav: false,
    dots: true,
    infinite: true,
    speed: 500,
    lazyLoad: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 0
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    // slidesToScroll: 1
};
const FeedbackArea = () => {
    const feedbackobj = [
        {
            id:1,
            img:"assets/img/client-image/1.webp",
            heading:"Naveen Kumar",
            post:"CEO",
            para:"I know I speak for all of our employees as I proudly inform you about our company and the ideals which we stand for Alobha's mission can be summed up in three words – Deliver, Technology & Innovation.",
        },
        {
            id:2,
            img:"assets/img/client-image/2.webp",
            heading:"Lajpat Baweja",
            post:"Director",
            para:"Alobha technologies is a dynamic and fast-growing, performance- based agency. Our primary goal as a team is to provide the best value possible to every organizationwe work with and for us that begins by providing.",
        },
        {
            id:3,
            img:"assets/img/client-image/3.webp",
            heading:"Asha Baweja",
            post:"Executive Director",
            para:"It is a privilege for one to be a part of such a growing and glooming company with a bright and innovative vision, Striving every step to enhance the industry with their technical background and skills. I wish to see Alobha and all the members of alobha to continue writing success stories in shimmering golden words ahead.",
        },
        {
            id:4,
            img:"assets/img/client-image/4.webp",
            heading:"Sanjeev Kumar",
            post:"Managing Director",
            para:"It is our endeavor to become of the top IT software solution while still remaining grounded in moral values. We are moving ahead with innovative ideas, strategies and technologies and have achieved. important milestone in our journey.",
        },
    ];
    return (
        <>
            <section className="ml-feedback-area ptb-80">
                <div className="container">
                    <div className="section-title">
                        <h2>Our Director Message</h2>
                        <div className="bar"></div>
                    </div>
                    <div className="ml-feedback-slides">
                        <Slider {...settings}>
                        {feedbackobj.map((fdslide) => {
                            return <div className="single-ml-feedback-item item" key={fdslide.id}>
                            <div className="client-info">
                                <img src={fdslide.img} alt="" loading="lazy" />
                            </div>
                            <h3>{fdslide.heading}</h3>
                            <span className="pb-2">{fdslide.post}</span>
                            <p className="text-justify">{fdslide.para}</p>
                        </div>
                        })}
                        </Slider >
                    </div>
                </div>
                <ShapeAnimation/>
            </section>
        </>
    )
}

export default FeedbackArea